import App from './components/App.vue'
import { store, dataStore } from './stores'
import { vueRouter } from './router'
import i18n from './i18n'

export default {
  elementId: 'client_site',
  rootComponent: App,
  vueRouter,
  stores: [
    {
      key: ['ClientSite'],
      module: store
    }
  ],
  i18n,
  // Vuetify is now configured globally in application.ts
  data: {
    dataStore: dataStore
  }
}
